import {UserService} from '../services';
import {Directive, OnInit, TemplateRef, ViewContainerRef, Input} from '@angular/core';

/**
 * <div *appShowAuthed="true"> Show this for logged in users
 */
@Directive({selector: '[appShowAuthed]'})
export class ShowAuthedDirective implements OnInit {

  condition: boolean;

  constructor(
    private templateRef: TemplateRef<any>,
    private userService: UserService,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit() {
    this.userService.isAuthenticated.subscribe(
      (isAuthenticated) => {
        if (isAuthenticated && this.condition || !isAuthenticated && !this.condition) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      }
    );
  }

  @Input()
  set appShowAuthed(condition: boolean) {
    this.condition = condition;
  }
}
